export default {
  toolBox: {
    title: "Helpful Tip",
    text: "This profile can populate the following:",
    formsArray: [
      {
        formCommonName: "H-2A TEMPORARY LABOR CERTIFICATION",
        formGovName: "FORM ETA-9142A",
        sections: ["SECTION D", "(PARTIAL)"],
      },
      {
        formCommonName: "CW-1 PREVAILING WAGE",
        formGovName: "FORM ETA-9141C",
        sections: ["SECTION B", "(PARTIAL)"],
      },
      {
        formCommonName: "CW-1 LABOR CERTIFICATION",
        formGovName: "FORM ETA-9142C",
        sections: ["SECTION D", "(PARTIAL)"],
      },
      {
        formCommonName: "H-2B | H-1B | PERM PREVAILING WAGE",
        formGovName: "FORM ETA-9141",
        sections: ["SECTION E", "(PARTIAL)"],
      },
      {
        formCommonName: "H-2B LABOR CERTIFICATION",
        formGovName: "FORM ETA-9142B",
        sections: ["SECTION C", "(PARTIAL)"],
      },
      {
        formCommonName: "PERM PERMANENT EMPLOYMENT CERTIFICATION",
        formGovName: "FORM ETA-9089",
        sections: ["SECTION C", "(PARTIAL)"],
      },
    ],
  },
};
